import { createContext, useState, ReactNode, FC, useEffect } from 'react'
import { getHistory } from '../../../../../domain/flag-management/flag-management.services'
import { Historical } from '../../domain/historical'

interface HistoricalContextProps {
  historical: Historical[] | undefined
  errorHistorical: boolean
  getJobHistorical: (jobId: string) => void
}

const HistoricalContext = createContext<HistoricalContextProps>({
  historical: [],
  errorHistorical: false,
  getJobHistorical: () => undefined
})

interface HistoricalProviderProps {
  children: ReactNode
}

const HistoricalProvider: FC<HistoricalProviderProps> = ({ children }) => {
  const [historical, setHistorical] = useState<Historical[]>(undefined)
  const [errorHistorical, setErrorHistorical] = useState<boolean>(false)

  useEffect(() => {
    return () => {
      setHistorical(undefined)
    }
  }, [])

  const getJobHistorical = async (jobId: string) => {
    setErrorHistorical(false)
    try {
      await getHistory(jobId).then((histories) => {
        setHistorical((_) => histories ?? [])
      })
    } catch (_) {
      setErrorHistorical(true)
    }
  }

  return (
    <HistoricalContext.Provider value={{ historical, getJobHistorical, errorHistorical }}>
      {children}
    </HistoricalContext.Provider>
  )
}

export { HistoricalContext, HistoricalProvider }
